import React from 'react';
import ExpenseReportHeader from './ExpenseReportHeader';
import ExpenseReportInfoSection from './ExpenseReportInfoSection';
import ExpenseReportEntries from './ExpenseReportEntries';
import ExpenseReportFooter from './ExpenseReportFooter';

export default function ExpenseReportDocument({ report, printRef }) {
  return (
    <div 
      ref={printRef} 
      id="expense-report-document" 
      className="bg-white w-full max-w-3xl shadow-xl rounded-lg overflow-hidden print:shadow-none print:rounded-none print:max-w-none" 
      style={{ fontFamily: "'Inter', system-ui, sans-serif" }}
    >
      <ExpenseReportHeader report={report} />
      
      <div className="px-6 py-4">
        <ExpenseReportInfoSection report={report} />
        <ExpenseReportEntries expenses={report.expenses} />
      </div>
      
      <ExpenseReportFooter report={report} />
    </div>
  );
}
